import React from 'react';
import { useTranslation } from 'react-i18next';

function Skills() {
  const { t } = useTranslation();

  const skillCategories = [
    {
      id: 'gis',
      title: t('skills.categories.gis.title'),
      items: t('skills.categories.gis.items', { returnObjects: true })
    },
    {
      id: 'photogrammetry',
      title: t('skills.categories.photogrammetry.title'),
      items: t('skills.categories.photogrammetry.items', { returnObjects: true })
    },
    {
      id: 'web',
      title: t('skills.categories.web.title'),
      items: t('skills.categories.web.items', { returnObjects: true })
    },
    {
      id: 'mobile',
      title: t('skills.categories.mobile.title'),
      items: t('skills.categories.mobile.items', { returnObjects: true })
    },
    {
      id: 'databases',
      title: t('skills.categories.databases.title'),
      items: t('skills.categories.databases.items', { returnObjects: true })
    },
    {
      id: 'design',
      title: t('skills.categories.design.title'),
      items: t('skills.categories.design.items', { returnObjects: true })
    },
    {
      id: 'systems',
      title: t('skills.categories.systems.title'),
      items: t('skills.categories.systems.items', { returnObjects: true })
    }
  ];

  return (
    <section className="skills-section" id="skills">
      <h3>{t('skills.title')}</h3>
      <div className="skills-grid">
        {skillCategories.map((category) => (
          <div key={category.id} className="skill-category">
            <h4>{category.title}</h4>
            <ul>
              {category.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills; 